import { Pipe, PipeTransform } from '@angular/core';
import { translateIncidentStatus } from '../mappers/enum-translation-mapper';

@Pipe({
  name: 'translateIncidentStatusEnum',
})
export class TranslateIncidentStatusEnumPipe implements PipeTransform {
  transform(value: any): any {
    return translateIncidentStatus(value);
  }
}
